const rules = {
  utils: {
    bodyData() {
      return $('body').data();
    }
  },

  account() {
    return this.utils.bodyData().isUserSignedIn;
  },

  confirmed_account() {
    return this.utils.bodyData().isUserEmailConfirmed;
  },

  trial() {
    return this.utils.bodyData().isUserFeatureTrial;
  },

  trialAndStandard() {
    return this.trial() && !this.subscription();
  },

  subscription() {
    return this.utils.bodyData().isUserSubscribed;
  },

  premium() {
    return (
      this.utils.bodyData().isUserPremium ||
      this.premiumPlus() ||
      this.black() ||
      this.unlimited() ||
      this.digitalUnlimited() ||
      this.judicial() ||
      this.judicialUnlimited()
    ); // FIXME MAYKE PLEASE
  },

  premiumPlus() {
    return this.utils.bodyData().isUserPremiumPlus;
  },

  black() {
    return this.utils.bodyData().isUserBlack;
  },

  unlimited() {
    return this.utils.bodyData().isUserUnlimited;
  },

  digitalUnlimited() {
    return this.utils.bodyData().isUserDigitalUnlimited;
  },

  judicial() {
    return this.utils.bodyData().isUserJudicial;
  },

  judicialUnlimited() {
    return this.utils.bodyData().isUserJudicialUnlimited;
  }
};

export default rules;
